import { render, staticRenderFns } from "./PatchesPage.vue?vue&type=template&id=2b31138e&scoped=true&"
import script from "./PatchesPage.vue?vue&type=script&lang=js&"
export * from "./PatchesPage.vue?vue&type=script&lang=js&"
import style0 from "./PatchesPage.vue?vue&type=style&index=0&id=2b31138e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b31138e",
  null
  
)

export default component.exports